export const panelLabelAnswerAI = "Risposta dell'AI:";
export const panelLabelArchive = "Archivio";
export const panelLabelCodici = "Codici";
export const panelLabelPrivate = "Privata";
export const panelLabelProjectNotShared =
  "Questo progetto non è condiviso con altri utenti";
export const panelLabelQuestion = "Domanda:";
export const panelLabelReportDate = "Data segnalazione";
export const panelLabelResolvedBy = "da";
export const panelLabelResolvedTime = "Risolto il ";
export const panelLabelSendBy = "Inviata da ";
export const panelLabelSources = "FONTI";
export const panelLabelUsedSources = " fonti utilizzate:";
export const panelLabelUsedSource = " fonte utilizzata:";
export const panelLabelUsers = "COLLABORATORI";
